import { withFilters } from 'coreOld/components';
import { IFiltersProps } from 'coreOld/types';
import { getListPayload } from 'coreOld/utils';
import { useGetJobList } from 'jobsOld/hooks';

import { columns } from './columns';
import RequestJobsTableView from './RequestJobsTableView';

interface IProps extends IFiltersProps {
  requestId: number;
}

const RequestJobsTable = ({ filters, requestId }: IProps) => {
  const { records, fetchNextPage, hasNextPage, isLoading, isFetching, isFetchingNextPage } =
    useGetJobList(getListPayload({ ...filters, supportRequestId: requestId }));

  return (
    <RequestJobsTableView
      tableColumns={columns}
      filters={filters}
      data={records}
      isLoading={isLoading || (isFetching && !isFetchingNextPage)}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};

export default withFilters(RequestJobsTable);
